import styled from 'styled-components';

import { Box } from '@shared/Grid';

import { animateIn, animateOut } from './utils';

export default styled(Box)`
  transition: opacity 0.25s, transform 0.2s;
  transition-delay: ${props => props.delay}ms;

  opacity: 0;
  transform: translateX(-8px);

  ${animateIn} {
    opacity: 1;
    transform: translateY(0);
  }
  ${animateOut} {
    opacity: 0;
    transform: translateX(-8px);
  }
`;
